export default __webpack_public_path__ + "static/media/Believer's Leggings of the Crumbling Tower.0ff4fd42.jpg";